<template>
  <div class="ab-mem-container">
    <div class="ab-mem-content">
      <div class="grid">
        <div class="about-card">
          <div
            class="about-card-details d-flex justify-content-between flex-wrap"
            :style="'background:' + row.bgColor1"
          >
            <div class="ac-inner-details">
              <div class="sub-title white-color" v-html="row.title1"></div>
              <div class="bg-title white-color" v-html="row.body1"></div>
              <router-link
                v-if="row.button1"
                class="ab-btn mt-2"
                :to="row.redirect1"
                >{{ row.button1 }}</router-link
              >
            </div>
            <div class="ac-inner-view">
              <img :src="row.image1_1" class="img-fluid" alt="" />
            </div>
          </div>
          <div
            class="about-card-view"
            :style="'backgroundImage: url(' + row.image1_2 + ')'"
          ></div>
        </div>

        <div class="mem-card" :style="'background:' + row.bgColor2">
          <div class="sub-title" v-html="row.title2"></div>
          <div class="bg-title white-color" v-html="row.subTitle2"></div>
          <div class="text white-color" v-html="row.body2"></div>
          <router-link v-if="row.button2" class="ab-btn" :to="row.redirect2">{{
            row.button2
          }}</router-link>
          <div class="mem-line" :style="'background:' + row.lineColor2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ab-mem-content {
  padding: 0.7rem 0;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 12.25rem;
  gap: 0.7rem;
  width: 100%;
}
.about-card > div {
  height: 50%;
}
.mem-card {
  padding: 80px 63px 100px;
  position: relative;
}
.mem-line {
  position: absolute;
  top: 87px;
  right: 63px;
  width: 14px;
  height: 130px;
}
.sub-title {
  color: #04cc88;
  font-size: 23px;
  font-weight: 600;
  margin-bottom: 12px;
}
.bg-title {
  font-size: 50px;
  margin-bottom: 17px;
}
.text {
  font-size: 20px;
  line-height: 1.3;
  margin-bottom: 50px;
}
.ab-btn {
  border: 1px solid #fff;
  padding: 9px 25px;
  line-height: 1;
  font-size: 17px;
  color: #fff;
  display: inline-block;
}
.ab-btn:hover {
  background: #fff;
  color: #000;
}
.ab-btn:active {
  opacity: 0.6;
}
.about-card-details {
  padding: 40px;
}
.about-card-view {
  background-size: cover;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
}

@media (max-width: 767.98px) {
  .grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .mem-card {
    padding: 60px 40px;
  }
  .mem-line,
  .ac-inner-view {
    display: none;
  }
  .about-card > div {
    height: auto;
  }
  .about-card-view {
    height: 220px !important;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .title {
    font-size: 25px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .ac-inner-view {
    display: none;
  }
  .sub-title {
    font-size: 21px;
  }
  .bg-title {
    font-size: 43px;
  }
  /* .about-card > div {
    height: auto;
  } */
  .about-card-view {
    height: 50% !important;
  }
  .mem-line {
    display: none;
  }
  /* .mem-card {
    padding: 82px 40px
  } */
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .ac-inner-view {
    display: none;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>

<script>
export default {
  name: "Section1",
  props: ["row"],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
    //
  },
  methods: {
    //
  },
};
</script>
